import React, { ReactElement } from 'react';
import { ACTION_LINK_ICON_NAME, ACTION_LINK_ICON_SIZE, ActionLink } from 'b2b-components/theme/components/ActionLink';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { Form } from './Form';
import { Props } from './';
import './ProductReportForm.scss';

const ProductReportForm = ({
  onFormShow,
  onFormHide,
  isFormVisible,
}: Props): ReactElement => {
  const t = useTranslate();
  return (
    <div className='ProductReportForm row'>
      <div className='col-12 col-lg-6'>
        {isFormVisible ? (
          <Form onFormHide={onFormHide} />
        ) : (
          <ActionLink
            iconName={ACTION_LINK_ICON_NAME.reportError}
            iconSize={ACTION_LINK_ICON_SIZE.small}
            onClick={onFormShow}
            className='ProductReportForm-Toggler'
          >
            {t('Report incorrect data')}
          </ActionLink>
        )}
      </div>
    </div>
  );
};

export { ProductReportForm };
